import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap } from 'rxjs/operators';

import * as actions from '@appStore/customers/actions';
import { CustomersActionTypes, CustomersUserAccessLoadData, SelectedCustomersUserAccessLoadData } from '@appStore/customers/actions';
import { CustomerService } from '@appStore/customers/services';

@Injectable()
export class CustomersEffects {
  constructor(private customerService: CustomerService, private actions$: Actions) {}

  loadMyCustomers$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomersActionTypes.CustomersLoadData),
      exhaustMap(action => {
        return this.customerService.getMyCustomers().pipe(
          map(customers => new actions.CustomersLoadSuccess(customers)),
          catchError(error => of(new actions.CustomersLoadFail(error)))
        );
      })
    );
  });
  
  loadMyCustomersUserAccess$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomersActionTypes.CustomersUserAccessLoadData),
      exhaustMap(action => {
        return this.customerService.getMyCustomersUserAccess().pipe(
          map(access => new actions.CustomersUserAccessLoadSuccess(access)),
          catchError(error => of(new actions.CustomersUserAccessLoadFail(error)))
        );
      })
    );
  });
  
  loadMyCustomersUsers$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomersActionTypes.CustomersUsersLoadData),
      exhaustMap(action => {
        return this.customerService.getMyCustomersUsers().pipe(
          map(users => new actions.CustomersUsersLoadSuccess(users)),
          catchError(error => of(new actions.CustomersUsersLoadFail(error)))
        );
      })
    ); 
  });
  
  loadExternalOrganisations$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomersActionTypes.CustomersExternalOrganisationsLoadData),
      exhaustMap(action => {
        return this.customerService.getExternalOrganisations().pipe(
          map(externalOrganisations => new actions.CustomersExternalOrganisationsLoadSuccess(externalOrganisations)),
          catchError(error => of(new actions.CustomersExternalOrganisationsLoadFail(error)))
        );
      })
    );
  });
  
  loadSelectedCustomersUserAccess$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomersActionTypes.SelectedCustomersUserAccessLoadData),
      exhaustMap((action: SelectedCustomersUserAccessLoadData) => {
        return this.customerService.getSelectedCustomersUserAccess(action.payload).pipe(
          map(access => new actions.SelectedCustomersUserAccessLoadSuccess(access)),
          catchError(error => of(new actions.SelectedCustomersUserAccessLoadFail(error)))
        );
      })
    );
  });
}
